export default __webpack_public_path__ + "static/media/image-dots.420b2aa0.png";